/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type StepUpdateLoanDraftDeviceAndLoanApprovalRequest = {
    referenceId?: string;
    loanId?: string;
    shopId: string;
    customerId?: string;
    citizenId?: string;
    passportNumber?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    citizenAddress?: string;
    currentAddress?: string;
    occupation?: string;
    workPlace?: string;
    email?: string;
    facebookUrl?: string;
    facebookName?: string;
    lineId?: string;
    instagramUrl?: string;
    instagramName?: string;
    tiktokUrl?: string;
    tiktokName?: string;
    firstReferencePersonFirstName: string;
    firstReferencePersonLastName: string;
    firstReferencePersonRelation: string;
    firstReferencePersonPhoneNumber: string;
    secondReferencePersonFirstName?: string;
    secondReferencePersonLastName?: string;
    secondReferencePersonRelation?: string;
    secondReferencePersonPhoneNumber?: string;
    type?: StepUpdateLoanDraftDeviceAndLoanApprovalRequest.type;
    note?: string;
    usedType?: StepUpdateLoanDraftDeviceAndLoanApprovalRequest.usedType;
    brand?: string;
    model?: string;
    color?: string;
    description?: string;
    warranty?: string;
    batteryPercent?: number;
    osType?: StepUpdateLoanDraftDeviceAndLoanApprovalRequest.osType;
    storage?: string;
    purchaseCost: number;
    installmentPlanFundSource?: StepUpdateLoanDraftDeviceAndLoanApprovalRequest.installmentPlanFundSource;
    downPaymentPercent: number;
    downPaymentAmount: number;
    downPaymentDate?: string;
    installmentCount?: number;
    installmentAmount?: number;
    installmentStartDate?: string;
    installmentFrequency?: number;
    installmentFrequencyType?: StepUpdateLoanDraftDeviceAndLoanApprovalRequest.installmentFrequencyType;
    deviceImei?: string;
    deviceSerialNumber?: string;
    interestRate?: number;
    loanBalance?: number;
    isFirstPaidPayment?: boolean;
    additionalCommissionAmount?: number;
    contractFeeAmount?: number;
    fineFeeAmount?: number;
    financeCommissionPercent?: number;
    shopAgentCommissionPercent?: number;
    unlockingFeeAmount?: number;
    isImportedByFinancier?: boolean;
};
export namespace StepUpdateLoanDraftDeviceAndLoanApprovalRequest {
    export enum type {
        ONLINE = 'ONLINE',
        OFFLINE = 'OFFLINE',
    }
    export enum usedType {
        NEW = 'NEW',
        USED = 'USED',
    }
    export enum osType {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
        OTHERS = 'OTHERS',
    }
    export enum installmentPlanFundSource {
        SHOP = 'SHOP',
        FINANCE = 'FINANCE',
    }
    export enum installmentFrequencyType {
        DAY = 'DAY',
        MONTH = 'MONTH',
    }
}

